import React from "react";
import { Helmet } from "react-helmet";
import { siteMetadata } from "../config/site";

function buildTitle(title) {
  if (!title || title === siteMetadata.title) {
    return siteMetadata.title;
  }

  return `${title} | ${siteMetadata.siteName}`;
}

function SEO({ title, description, path = "/", exactTitle = false, siteName }) {
  const pageTitle = exactTitle ? title : buildTitle(title);
  const pageDescription = description || siteMetadata.description;
  const canonicalUrl = `${siteMetadata.baseUrl}${path === "/" ? "" : path}`;
  const imageUrl = `${siteMetadata.baseUrl}${siteMetadata.image}`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="author" content={siteMetadata.author} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName || siteMetadata.siteName} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}

export default SEO;
